// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareLinkStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";
import Share from "@guestsupply/XDL/Icons/Share";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import Printer from "@insite/mobius/Icons/Printer";
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 32px;
        ${xScreen("lte", "md")} {
            justify-content: space-between;
        }
    `,
};
shareLinkStyles.printLink = {
    ...createLinkIconStyles(Printer, {
        icon: {
            position: "left",
            iconProps: {
                size: 16,
            },
        },
    }),
};
shareLinkStyles.link = {
    link: {
        ...mergeWithCss(createLinkIconStyles(Share), {
            icon: {
                position: "left",
                iconProps: {
                    size: 16,
                    css: css`
                        ${IconWrapper}, svg {
                            width: 14px;
                            height: 16px;
                        }
                    `,
                },
            },
        }),
    },
};
